"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddBlockMenuItem = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var AddBlockMenuItem = (0, mobx_react_1.observer)(function (_a) {
    var disabledTooltipContent = _a.disabledTooltipContent, isDisabled = _a.isDisabled, onClick = _a.onClick, icon = _a.icon, text = _a.text;
    var showTooltip = isDisabled ? undefined : false;
    return (react_1.default.createElement(kaleidoscope_1.Tooltip, { size: kaleidoscope_1.TooltipSize.Large, position: kaleidoscope_1.TooltipPosition.Top, content: disabledTooltipContent, show: showTooltip, wrapTarget: isDisabled, className: "add-block-menu-item__disabled-tooltip", offset: 0 },
        react_1.default.createElement("button", { onMouseUp: utils_1.handleMouseUpByBlurring, className: (0, classnames_1.default)("add-block-menu-item", { "add-block-menu-item--disabled": isDisabled }), onClick: onClick, disabled: isDisabled },
            react_1.default.createElement("div", { className: "add-block-menu-item-inner" },
                react_1.default.createElement("div", { className: "space-stack-xs" }, icon),
                react_1.default.createElement("div", { className: "add-block-menu-item-text" }, text)))));
});
exports.AddBlockMenuItem = AddBlockMenuItem;
